import { combineReducers } from "redux"
import search from "src/store/search/reducers"

const rootReducer = combineReducers({
  search,
})

export default rootReducer
